import type { IRegionValueDataOfRegionSelector } from '@/pages/intelligence/types/pcConsoleCompare';

export interface IPcConsoleCompareState {
  filter: {
    regionData: IRegionValueDataOfRegionSelector;
  };
}

export const PC_CONSOLE_COMPARE_NAMESPACE = 'intelligence_pc_console_compare';

const MonetizationModel = {
  namespace: PC_CONSOLE_COMPARE_NAMESPACE,

  state: {
    filter: {
      // 国家筛选器数据，直接保存组件返回的数据，不要做任何处理，方便回显时，组件能正常显示，接口入参跟组件的数据不一致，请在service层 自行处理
      regionData: {
        type: 'market',
        regions: [],
        markets: ['global'],
      },
    },
  },

  effects: {},

  reducers: {
    saveFilterRegionData(state: IPcConsoleCompareState, action: any) {
      const regionDataTemp = action?.payload;
      const typeTemp = regionDataTemp?.type || 'market';
      let regionsTemp = regionDataTemp?.regions;
      let marketsTemp = regionDataTemp?.markets;
      regionsTemp = Array.isArray(regionsTemp) && regionsTemp?.length ? regionsTemp : [];
      marketsTemp = Array.isArray(marketsTemp) && marketsTemp?.length ? marketsTemp : [];

      return {
        ...state,
        filter: {
          ...state?.filter,
          regionData: {
            type: typeTemp,
            regions: regionsTemp,
            markets: marketsTemp,
          },
        },
      };
    },
  },
};

export default MonetizationModel;
